<template>
  <div class="AddVehicle">
    <QS-h4-title title="车辆选择" />
    <!-- 订车车型 和 添加车辆 -->
    <el-form :model="addVehicleInfo" ref="addVehicleRef" :rules="addVehicleRules" :inline="true">
      <CarBrandSeriesModel
        v-model="addVehicleInfo.brandSeriesModel"
        :showModel="true"
        :filterScene="CAR_MODEL_FILTER_SCENE.IN_STOCK"
        ></CarBrandSeriesModel>
      <el-form-item :label="'添加车辆' + columnSeparator" prop="plateNo">
        <el-select
          placeholder="请选择"
          v-model="addVehicleInfo.plateNo"
          clearable
          filterable
          remote
          :optionData="carList"
          :loading="loadingCarList"
          :remote-method="fuzzySearch"
          @change="handleChange"
        >
          <el-option v-for="item in carList" :key="item.id" :label="item.label" :value=item.value />
        </el-select>
      </el-form-item>
      <el-button @click="addCarFn" class="button" type="primary">添加</el-button>
    </el-form>
    <div class="batch-add">
      <span>
        <el-button
          :loading="loading.upload"
          type="primary"
          @click="uploadCar"
          size="mini"
        >批量添加车辆</el-button>
      </span>
    </div>
    <!-- table组件 -->
    <QS-common-table
      :data="addVehicleTable"
      :columns="headColumn"
      :pagination="false"
      class="mt16"
    />
    <!-- 批量添加车辆 -->
    <ImportPopup
      ref="importPopup"
      title="批量添加车辆"
      :templateUrl="addCarTemplate"
      :upload="uploadFn"
      group="order"
      code="order_vehicle_pic"
    >
      <div class="importInstructions">
        <div>
          <p>
            这个功能的前提是，您已经制作了一张目标表单希望直接将Excel转移到系统，请单击
            下载Excel标准模板。
          </p>
          <span>导入前准备</span>
          <ul>
            <li v-for="item of importInstructionsList" :key="item">
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </ImportPopup>
    <div class="totalContainer">
      <span style="margin-right: 40px">车辆已添加台数： {{ carTotalSNum }}台</span>
    </div>
    <!-- 导入失败-弹窗 -->
    <dialogWrap
      v-model="uploadDialogShow"
      title="导入失败提示"
      :width="'750px'"
      class="spring-frame"
      :before-close="beforeUploadClose"
    >
      <p
        v-for="(item, index) in uploadTableData"
        :key="index"
        style="margin-bottom: 8px"
      >
        {{ item }}
      </p>
    </dialogWrap>
  </div>
</template>
<script>
import ImportPopup from '@/components/ImportPopup'
import moment from 'moment'
import { debounce } from 'lodash'
import { searchCarsByPlateNoVin } from '@/api/domain/cars.js'
import { purchaseCarAddImport } from '@/api/domain/purchase.js'
import { addCarTemplate } from '@/config'
import { operateMaxShowLength } from '@/store/dict/config'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default {
  name: 'PurAddVehicle',
  components: { ImportPopup },
  props: {
    purchaseOrderId: {
      type: [Number, String],
      default: '',
    },
    deptId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      addVehicleRules: {
        modelId: [
          {
            required: true,
            message: '车型不能为空',
            trigger: 'change',
          },
        ],
        brandId: [
          {
            required: true,
            message: '请选择品牌',
            trigger: 'change',
          },
        ],
        plateNo: [
          {
            required: true,
            message: '添加车辆不能为空',
            trigger: 'change',
          },
        ],

      },
      // form
      addVehicleInfo: {
        modelId: '',
        plateNo: '',
        brandSeriesModel: {},
        brandId: '',
        seriesId: '',
      },
      carList: [], // 车辆列表
      // 导入说明列表
      importInstructionsList: [
        '1.请使用标准模板，确认未进行过任何更改，若无意中修改了模板的原有内容，建议重新下载模板；',
        '2.确保Excel中标题行的名称和表单中与之对应的字段标题一致，且表单中字段名称不能相同；',
        '3.确保Excel中数据没有任何颜色样式，否则将与导入功能的错误提示混淆；',
        '4.确保excel中数据格式正确。比如VIN码为数字加字母格式，请不要输入汉字。',
        '5.如果表单中有设置必填项字段，在Excel中对应的列下，都必须有数据/值；',
        '6.Excel多余的列无法导入，请删除Excel中不需要导入的列；',
      ],
      addVehicleTable: [],
      addCarTemplate,
      loading: {
        upload: false,
      },
      currentPlateNoId: '', // 当前选择的车辆
      uploadDialogShow: false, // 导入失败弹窗
      uploadTableData: [], // 导入失败数据
      headColumn: [
        {
          name: 'index',
          columnProps: {
            prop: 'index',
            label: '序号',
          },
        },
        {
          name: 'carId',
          columnProps: {
            prop: 'carId',
            label: '车辆ID',
          },
        },
        {
          name: 'brandName',
          columnProps: {
            prop: 'brandName',
            label: '品牌',
          },
        },
        {
          name: 'seriesName',
          columnProps: {
            prop: 'seriesName',
            label: '车系',
          },
        },
        {
          name: 'carModelName',
          columnProps: {
            prop: 'carModelName',
            label: '车型',
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
          },
        },
        {
          name: 'deptName',
          columnProps: {
            prop: 'deptName',
            label: '所属部门',
            width: 100,
          },
        },
        {
          name: 'vin',
          columnProps: {
            prop: 'vin',
            label: 'VIN码',
          },
        },
        {
          name: 'addDate',
          columnProps: {
            prop: 'addDate',
            label: '添加时间',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            width: 240,
            fixed: 'right',
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ $index }) => {
            const optionArray = [
              {
                name: 'del',
                label: '删除',
                action: () => this.dataDelete($index),
              },
            ]
            return optionArray
          },
        },
      ],
      // 车辆列表加载标识
      loadingCarList: false,
      CAR_MODEL_FILTER_SCENE,
    }
  },
  computed: {
    // 车辆实收
    carTotalSNum() {
      return this.addVehicleTable.length
    },
  },
  watch: {
    'addVehicleInfo.brandSeriesModel': {
      handler(val) {
        const { brandId, seriesId, modelId } = val
        this.addVehicleInfo.brandId = brandId
        this.addVehicleInfo.seriesId = seriesId
        this.addVehicleInfo.modelId = modelId
        this.$nextTick(() => {
          this.$refs.addVehicleRef.clearValidate('brandId')
          this.$refs.addVehicleRef.clearValidate('modelId')
        })
        if (modelId) {
          this.modelChange()
        }
      },
      deep: true,
    },
  },
  methods: {
    // 导入车辆
    uploadCar() {
      this.$refs.importPopup.showDialog()
    },
    // 删除
    dataDelete(index) {
      this.addVehicleTable.splice(index, 1)
    },
    beforeUploadClose() {
      this.uploadTableData = []
      this.uploadDialogShow = false
    },
    // 手动添加
    addCarFn() {
      this.$refs.addVehicleRef.validate((valid) => {
        if (!valid) {
          return false
        }
        this.carList.forEach((item) => {
          if (item.id === this.currentPlateNoId) {
            if (
              this.addVehicleTable.some(
                (dataItem) => dataItem.id === this.currentPlateNoId,
              )
            ) {
              this.$message.error('该车辆已添加')
              return
            }
            item.addDate = moment().format('YYYY-MM-DD HH:mm:ss')
            item.carId = item.id
            item.carModelName = item.modelName
            this.addVehicleTable.push(item)
          }
          // 添加index-序号属性
          this.addVehicleTable.forEach((ite, index) => {
            ite.index = index + 1
          })
        })
      })
    },
    // 导入文件的返回值
    uploadFn(url) {
      return new Promise((resolve, reject) => {
        purchaseCarAddImport({
          orderId: this.purchaseOrderId,
          fileAddress: url,
        }).then((res) => {
          const { code, data } = res
          if (code === 1) {
            if (data?.orderCarInfos?.length > 0) {
              this.$message({
                message: '导入成功',
                type: 'success',
              })
              this.addCarData(data.orderCarInfos)
              // 添加index-序号属性
              this.addVehicleTable.forEach((item, index) => {
                item.index = index + 1
              })
              this.$refs.importPopup.closeDialog()
            }
            resolve()
          }
          this.fileList = []
        }).catch(() => {
          reject()
        })
      })
    },
    // 车型变更
    async modelChange() {
      this.carList = []
      this.addVehicleInfo.plateNo = ''
      this.currentPlateNoId = ''
      this.loadingCarList = true
      const { code, data } = await searchCarsByPlateNoVin({
        state: 4, // 代表待采购车辆
        modelId: this.addVehicleInfo.modelId,
        pageSize: 50, // 切换车型初次加载50条数据
        deptId: this.deptId,
      })
      this.loadingCarList = false
      if (code === 1) {
        this.carList = data?.items.map((item) => {
          return {
            ...item,
            label: item.plateNo || item.vin,
            value: item.id,
          }
        })
      }
    },
    // 车辆选择
    handleChange(plateNoId) {
      this.currentPlateNoId = plateNoId
    },
    // 添加车辆
    addCarData(data) {
      // 去重
      const newArr = data.reduce((total, item) => {
        if (
          !this.addVehicleTable.some(
            (t) => Number(t.carId) === Number(item.carId),
          )
        ) {
          total = total.concat([item])
        }
        return total
      }, [])
      this.addVehicleTable.push(...newArr)
    },
    // 远程搜索
    fuzzySearch: debounce(function (fuzzyField) {
      if (fuzzyField.length < 4 || !this.addVehicleInfo.modelId) return
      this.loadingCarList = true
      searchCarsByPlateNoVin({
        state: 4, // 代表待采购车辆
        modelId: this.addVehicleInfo.modelId,
        fuzzyField,
      }).then((res) => {
        const { code, data } = res || {}
        if (code === 1) {
          this.carList = data?.items.map((item) => {
            return {
              ...item,
              label: item.plateNo || item.vin,
              value: item.id,
            }
          })
        }
      }).finally(() => {
        this.loadingCarList = false
      })
    }, 400),
  },
}
</script>
<style lang="scss" scoped>
.AddVehicle {
  .button {
    justify-content: center;
    width: 60px !important;
    margin-left: 20px;
  }
}
.totalContainer {
  padding: 15px 10px;
  font-weight: bold;
}
.batch-add {
  overflow: hidden;
  span {
    float: right;
    padding-right: 20px;
  }
}
</style>
